
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface MembershipPurchase {
  id: string;
  user_id: string;
  membership_id: string;
  provider_id: string;
  amount: number;
  currency: string;
  status: string;
  purchase_date: string;
  created_at: string;
  stripe_session_id?: string;
  coupon_discount_amount?: number;
  membership: {
    id: string;
    name: string;
    membership_type: string;
    session_count: number | null;
  } | null;
  user_profile: {
    first_name: string | null;
    last_name: string | null;
    email: string | null;
  } | null;
}

export const useMembershipPurchases = (providerId?: string) => {
  return useQuery({
    queryKey: ['membership-purchases', providerId],
    queryFn: async () => {
      if (!providerId) return [];
      
      console.log('Fetching membership purchases for provider:', providerId);
      
      const { data, error } = await supabase
        .from('membership_purchases')
        .select(`
          *,
          membership:memberships(
            id,
            name,
            membership_type,
            session_count
          ),
          user_profile:profiles!membership_purchases_user_id_fkey(
            first_name,
            last_name,
            email
          )
        `)
        .eq('provider_id', providerId)
        .order('created_at', { ascending: false });

      if (error) {
        console.error('Error fetching membership purchases:', error);
        throw error;
      }

      console.log('Membership purchases fetched:', data);
      
      // Type-safe conversion with proper null handling
      const typedData: MembershipPurchase[] = (data || []).map(item => ({
        id: item.id,
        user_id: item.user_id,
        membership_id: item.membership_id,
        provider_id: item.provider_id,
        amount: item.amount,
        currency: item.currency,
        status: item.status,
        purchase_date: item.purchase_date,
        created_at: item.created_at,
        stripe_session_id: item.stripe_session_id,
        coupon_discount_amount: item.coupon_discount_amount,
        membership: item.membership ? {
          id: item.membership.id,
          name: item.membership.name,
          membership_type: item.membership.membership_type,
          session_count: item.membership.session_count
        } : null,
        user_profile: item.user_profile ? {
          first_name: item.user_profile.first_name,
          last_name: item.user_profile.last_name,
          email: item.user_profile.email
        } : null
      }));
      
      return typedData;
    },
    enabled: !!providerId,
  });
};
